import { useMemo } from "react";

import { isNonEmptyArray } from "_helpers";

import { Form, Tag } from "antd";

import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
dayjs.extend(customParseFormat);

export const RangePickerFooter = ({ itemName, itemValues }) => {
    const form = Form.useFormInstance();

    let ranges = useMemo(() => {
        return {
            from: {
                'Le début': [dayjs('1970-01-01', true), dayjs()]
            },
            between: {
                'L\'année dernière': [dayjs().subtract(1,'year').startOf('year'), dayjs().subtract(1,'year').endOf('year')],
                'Le mois dernier': [dayjs().subtract(1,'month').startOf('month'), dayjs().subtract(1,'month').endOf('month')],
            },
            to: {

            }
        } 
    }, [])

    if( isNonEmptyArray(itemValues) ){
        ranges['to']['Aujourd\'hui'] = [itemValues[0], dayjs()];
        ranges['to']['Dernier jour du mois dernier'] = [itemValues[0], dayjs().subtract(1,'month').endOf('month')];
    }

    const onChange = ( name, value ) => {
        form.setFieldsValue({[name]: value});
    }

    return(
        <>
            <div>
                Depuis :
                {
                    Object.entries(ranges.from).map(entry => {
                        const [ property, value ] = entry;

                        return(
                            <Tag key={property} color="blue" className="mx-1" style={{cursor: "pointer"}} onClick={() => onChange(itemName, value)}>{property}</Tag>
                        );
                    })
                }
            </div>
            <div>
                Sur la période :
                {
                    Object.entries(ranges.between).map(entry => {
                        const [ property, value ] = entry;

                        return(
                            <Tag key={property} color="blue" className="mx-1" style={{cursor: "pointer"}} onClick={() => onChange(itemName, value)}>{property}</Tag>
                        );
                    })
                }
            </div>
            {
                isNonEmptyArray(itemValues) &&
                    <div>
                        À/Au :
                        {
                            Object.entries(ranges.to).map(entry => {
                                const [ property, value ] = entry;

                                return(
                                    <Tag key={property} color="blue" className="mx-1" style={{cursor: "pointer"}} onClick={() => onChange(itemName, value)}>{property}</Tag>
                                );
                            })
                        }
                    </div>
            }
        </>
    );
}